export default __webpack_public_path__ + "static/media/slider-unraf-4.82bd0260.jpg";